import { AbstractGetAllStore } from "../common/AbstractStores";
import Dispatcher from "../common/dispatcher";
import Actions from "./TechiniciansActions";
import { TechnicianDto } from "../generated";

class TechinicansStore extends AbstractGetAllStore<TechnicianDto>{
    constructor() {
        super(x => x.id.toString());
        Dispatcher
            .onfunction(Actions.getAll, result => this.setAll(result))
            .onfunction(Actions.add, result => this.updateOrAdd(result))
            .onfunction(Actions.update, result => this.updateOrAdd(result))

    }
    public useAll = () => this.useAllWithAction(() => Actions.getAll());
    public use = (id: number | null) => this.useWithAction(() => Actions.getAll(), id?.toString() ?? null);
}

export default new TechinicansStore()
